import Layout from "./components/layout/Layout";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { lazy, Suspense } from "react";
import ScrollToTop from "./components/ScrollToTop";
import CustomHelmetProvider from "./components/HelmetProvider";

// Lazy load all pages
const OrganizationPage = lazy(
  () => import("./components/pages/OrganizationPage")
);
const SponsorsPage = lazy(() => import("./components/pages/SponsorsPage"));
const HomePage = lazy(() => import("./components/pages/HomePage"));
const OverviewPage = lazy(() => import("./components/pages/OverviewPage"));
const WelcomeMessagePage = lazy(
  () => import("./components/pages/WelcomeMessagePage")
);
const SchedulePage = lazy(() => import("./components/pages/SchedulePage"));
const SpeakersPage = lazy(() => import("./components/pages/SpeakersPage"));
const FieldActivitiesPage = lazy(
  () => import("./components/pages/FieldActivitiesPage")
);
const FAQsPage = lazy(() => import("./components/pages/FAQsPage"));
const SubmissionGuidelinesPage = lazy(
  () => import("./components/pages/SubmissionGuidelinesPage")
);
const ImportantDatesPage = lazy(
  () => import("./components/pages/ImportantDatesPage")
);
const YouthSummitPage = lazy(
  () => import("./components/pages/YouthSummitPage")
);
const GifthonePage = lazy(() => import("./components/pages/GifthonePage"));
const AboutUBTPage = lazy(() => import("./components/pages/AboutUBTPage"));
const AccomodationPage = lazy(
  () => import("./components/pages/AccomodationPage")
);
const JeddahOverviewPage = lazy(
  () => import("./components/pages/JeddahOverviewPage")
);
const VisaInformationPage = lazy(
  () => import("./components/pages/VisaInformationPage")
);
const RegistrationPage = lazy(
  () => import("./components/pages/RegistrationPage")
);
const PaymentPage = lazy(() => import("./components/pages/PaymentPage"));
const PaymentSuccessPage = lazy(
  () => import("./components/pages/PaymentSuccessPage")
);
const PaymentVerificationPage = lazy(
  () => import("./components/pages/PaymentVerificationPage")
);
const PaymentFailedPage = lazy(
  () => import("./components/pages/PaymentFailedPage")
);
const TermsAndConditionsPage = lazy(
  () => import("./components/pages/TermsAndConditionsPage")
);
const PrivacyPolicyPage = lazy(
  () => import("./components/pages/PrivacyPolicyPage")
);
const RegistrationReceiptPage = lazy(
  () => import("./components/pages/RegistrationReceiptPage")
);
const QrReceiptPage = lazy(() => import("./components/pages/QrReceiptPage"));
const InvoicePrintPage = lazy(
  () => import("./components/pages/InvoicePrintPage")
);
const YouthSummitSchedulePage = lazy(
  () => import("./components/pages/YouthSummitSchedulePage")
);
const HTMLSitemapPage = lazy(
  () => import("./components/pages/HTMLSitemapPage")
);
const ConferenceDatesPage = lazy(
  () => import("./components/pages/ConferenceDatesPage")
);
const YouthSummitRegistrationPage = lazy(
  () => import("./components/pages/YouthSummitRegistrationPage")
);
const YouthSummitPaymentPage = lazy(
  () => import("./components/pages/YouthSummitPaymentPage")
);
const CallForMentorsPage = lazy(
  () => import("./components/pages/CallForMentorsPage")
);
const SymposiumsPage = lazy(() => import("./components/pages/SymposiumsPage"));
const PreConferenceWorkshopsPage = lazy(
  () => import("./components/pages/PreConferenceWorkshopsPage")
);
const WorkshopDetailPage = lazy(
  () => import("./components/pages/WorkshopDetailPage")
);
const PanelistDetailPage = lazy(
  () => import("./components/pages/PanelistDetailPage")
);
const WTCGPanelistDetailPage = lazy(
  () => import("./components/pages/WTCGPanelistDetailPage")
);
const URGPanelistDetailPage = lazy(
  () => import("./components/pages/URGPanelistDetailPage")
);
const ThakaatPanelistDetailPage = lazy(
  () => import("./components/pages/ThakaatPanelistDetailPage")
);
const KfuPanelistDetailPage = lazy(
  () => import("./components/pages/KfuPanelistDetailPage")
);
const ETCQiyasPanelistDetailPage = lazy(
  () => import("./components/pages/ETCQiyasPanelistDetailPage")
);
const SBMFPanelistDetailPage = lazy(
  () => import("./components/pages/SBMFPanelistDetailPage")
);
const MawhibaPanelistDetailPage = lazy(
  () => import("./components/pages/MawhibaPanelistDetailPage")
);
const KingFaisalPanelistDetailPage = lazy(
  () => import("./components/pages/KingFaisalPanelistDetailPage")
);
const AGUPanelistDetailPage = lazy(
  () => import("./components/pages/AGUPanelistDetailPage")
);
const UBTPanelistDetailPage = lazy(
  () => import("./components/pages/UBTPanelistDetailPage")
);
const UFJPanelistDetailPage = lazy(
  () => import("./components/pages/UFJPanelistDetailPage")
);
const EffatPanelistDetailPage = lazy(
  () => import("./components/pages/EffatPanelistDetailPage")
);
const STEMPanelistDetailPage = lazy(
  () => import("./components/pages/STEMPanelistDetailPage")
);
const UNESCOPanelistDetailPage = lazy(
  () => import("./components/pages/UNESCOPanelistDetailPage")
);
const RCQEPanelistDetailPage = lazy(
  () => import("./components/pages/RCQEPanelistDetailPage")
);
const BGCDPanelistDetailPage = lazy(
  () => import("./components/pages/BGCDPanelistDetailPage")
);
const JohnsHopkinsPanelistDetailPage = lazy(
  () => import("./components/pages/JohnsHopkinsPanelistDetailPage")
);
const APFGPanelistDetailPage = lazy(
  () => import("./components/pages/APFGPanelistDetailPage")
);
const MinistryOfEducationPanelistDetailPage = lazy(
  () => import("./components/pages/MinistryOfEducationPanelistDetailPage")
);
const WGCPanelistDetailPage = lazy(
  () => import("./components/pages/WGCPanelistDetailPage")
);
const ArabCouncilPanelistDetailPage = lazy(
  () => import("./components/pages/ArabCouncilPanelistDetailPage")
);
const OECDPanelistDetailPage = lazy(
  () => import("./components/pages/OECDPanelistDetailPage")
);
const WorkshopMaterialsPage = lazy(
  () => import("./components/pages/WorkshopMaterialsPage")
);
const WorkshopRegistrationPage = lazy(
  () => import("./components/pages/WorkshopRegistrationPage")
);
const WorkshopBillingPage = lazy(
  () => import("./components/pages/WorkshopBillingPage")
);
const YouthSummitMaterialsPage = lazy(
  () => import("./components/pages/YouthSummitMaterialsPage")
);
const ConferenceBookletPage = lazy(
  () => import("./components/pages/ConferenceBookletPage")
);
const KeynoteSpeakerDetailPage = lazy(
  () => import("./components/pages/KeynoteSpeakerDetailPage")
);
const TripRegistrationPage = lazy(
  () => import("./components/pages/TripRegistrationPage")
);
const ResourcesPage = lazy(
  () => import("./components/pages/ResourcesPage")
);
const ComplimentaryRegistrationPage = lazy(
  () => import("./components/pages/ComplimentaryRegistrationPage")
);
const PaperPresentationsDetailPage = lazy(
  () => import("./components/pages/PaperPresentationsDetailPage")
);


// Loading component
const LoadingSpinner = () => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
      fontSize: "18px",
      color: "#666",
    }}
  >
    Loading...
  </div>
);

function App() {
  return (
    <CustomHelmetProvider>
      <BrowserRouter>
        {/* Animate to Top when browser page is changed */}
        <ScrollToTop />

        <Suspense fallback={<LoadingSpinner />}>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<HomePage />} />
              <Route path="overview" element={<OverviewPage />} />
              <Route path="welcome-message" element={<WelcomeMessagePage />} />
              <Route
                path="organizing-committee"
                element={<OrganizationPage />}
              />
              <Route path="organization" element={<OrganizationPage />} />
              <Route path="sponsors" element={<SponsorsPage />} />
              <Route path="schedule" element={<SchedulePage />} />
              <Route path="paper-presentations" element={<PaperPresentationsDetailPage />} />
              <Route path="speakers" element={<SpeakersPage />} />
              <Route
                path="keynote-speaker/:speakerId"
                element={<KeynoteSpeakerDetailPage />}
              />
              <Route
                path="field-activities"
                element={<FieldActivitiesPage />}
              />
              <Route
                path="trip-registration"
                element={<TripRegistrationPage />}
              />
              <Route path="symposiums" element={<SymposiumsPage />} />
               <Route
                 path="pre-conference-workshops"
                 element={<PreConferenceWorkshopsPage />}
               />
               <Route
                  path="workshop-materials"
                  element={<WorkshopMaterialsPage />}
                />
                <Route
                  path="pre-conference-workshop"
                  element={<WorkshopMaterialsPage />}
                />
               <Route
                 path="workshop/:workshopId"
                 element={<WorkshopDetailPage />}
               />
               <Route
                 path="panelist/:panelistId"
                 element={<PanelistDetailPage />}
               />
               <Route
                 path="wtcg-panelist/:panelistId"
                 element={<WTCGPanelistDetailPage />}
               />
               <Route
                 path="urg-panelist/:panelistId"
                 element={<URGPanelistDetailPage />}
               />
               <Route
                 path="thakaat-panelist/:panelistId"
                 element={<ThakaatPanelistDetailPage />}
               />
              <Route
                path="kfu-panelist/:panelistId"
                element={<KfuPanelistDetailPage />}
              />
              <Route
                path="etcqiyas-panelist/:panelistId"
                element={<ETCQiyasPanelistDetailPage />}
              />
              <Route
                path="sbmf-panelist/:panelistId"
                element={<SBMFPanelistDetailPage />}
              />
              <Route
                path="mawhiba-panelist/:panelistId"
                element={<MawhibaPanelistDetailPage />}
              />
              <Route
                path="king-faisal-panelist/:panelistId"
                element={<KingFaisalPanelistDetailPage />}
              />
               <Route
                path="agu-panelist/:panelistId"
                element={<AGUPanelistDetailPage />}
              />
               <Route
                path="ubt-panelist/:panelistId"
                element={<UBTPanelistDetailPage />}
              />
               <Route
                path="ufj-panelist/:panelistId"
                element={<UFJPanelistDetailPage />}
              />
               <Route
                path="effat-panelist/:panelistId"
                element={<EffatPanelistDetailPage />}
              />
               <Route
                path="stem-panelist/:panelistId"
                element={<STEMPanelistDetailPage />}
              />
               <Route
                 path="unesco-panelist/:panelistId"
                 element={<UNESCOPanelistDetailPage />}
               />
               <Route
                 path="rcqe-panelist/:panelistId"
                 element={<RCQEPanelistDetailPage />}
               />
               <Route
                 path="bgcd-panelist/:panelistId"
                 element={<BGCDPanelistDetailPage />}
               />
               <Route
                 path="johns-hopkins-panelist/:panelistId"
                 element={<JohnsHopkinsPanelistDetailPage />}
               />
              <Route
                path="apfg-panelist/:panelistId"
                element={<APFGPanelistDetailPage />}
              />
              <Route
                path="ministry-of-education-panelist/:panelistId"
                element={<MinistryOfEducationPanelistDetailPage />}
              />
              <Route
                path="wgc-panelist/:panelistId"
                element={<WGCPanelistDetailPage />}
              />
              <Route
                path="arab-council-panelist/:panelistId"
                element={<ArabCouncilPanelistDetailPage />}
              />
              <Route
                path="oecd-panelist/:panelistId"
                element={<OECDPanelistDetailPage />}
              />
               <Route
                 path="register-workshop"
                 element={<WorkshopRegistrationPage />}
               />
               <Route
                 path="workshop-registration"
                 element={<WorkshopRegistrationPage />}
               />
               
               <Route path="youth-summit" element={<YouthSummitPage />} />
               <Route
                 path="youth-summit-materials"
                 element={<YouthSummitMaterialsPage />}
               />
              <Route
                path="youth-summit-schedule"
                element={<YouthSummitSchedulePage />}
              />
              <Route
                path="youth-summit-registration"
                element={<YouthSummitRegistrationPage />}
              />
              <Route path="gifthone" element={<GifthonePage />} />
              <Route path="call-for-mentors" element={<CallForMentorsPage />} />
              <Route
                path="submission-guidelines"
                element={<SubmissionGuidelinesPage />}
              />
              <Route path="important-dates" element={<ImportantDatesPage />} />
              <Route
                path="conference-dates"
                element={<ConferenceDatesPage />}
              />
              <Route
                path="conference-booklet"
                element={<ConferenceBookletPage />}
              />
              <Route path="about-ubt" element={<AboutUBTPage />} />
              <Route path="accomodation" element={<AccomodationPage />} />
              <Route path="jeddah-overview" element={<JeddahOverviewPage />} />
              <Route
                path="visa-information"
                element={<VisaInformationPage />}
              />
              <Route path="resources" element={<ResourcesPage />} />
              <Route path="faqs" element={<FAQsPage />} />
              <Route path="register" element={<RegistrationPage />} />
              <Route path="registration" element={<RegistrationPage />} />
              <Route path="registeration" element={<RegistrationPage />} />
              <Route path="complimentary-registration" element={<ComplimentaryRegistrationPage />} />
              <Route path="sitemap" element={<HTMLSitemapPage />} />

              <Route
                path="terms-and-conditions"
                element={<TermsAndConditionsPage />}
              />
              <Route path="privacy-policy" element={<PrivacyPolicyPage />} />

              <Route path="payment-success" element={<PaymentSuccessPage />} />
              <Route path="payment-failed" element={<PaymentFailedPage />} />
              <Route
                path="payment-verify"
                element={<PaymentVerificationPage />}
              />
              <Route
                path="receipt/:apcgId"
                element={<RegistrationReceiptPage />}
              />
              <Route path="qr/:kind/:apcgId" element={<QrReceiptPage />} />
              <Route
                path="invoice-print"
                element={<InvoicePrintPage />}
              />
            </Route>
            <Route path="payment" element={<PaymentPage />} />
            <Route path="workshop-billing" element={<WorkshopBillingPage />} />
            <Route
              path="youth-summit-payment"
              element={<YouthSummitPaymentPage />}
            />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </CustomHelmetProvider>
  );
}

export default App;
